// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"6dfada8e","569":"3cb0014a"}[chunkId] + ".chunk.js";
};